import { useEffect } from 'react';
import { useMiningStore } from '../../../Store/miningStore';
import { TimeRemaining } from '../types/mining.types';

export const useMiningTime = () => {
  const updateMiningStatus = useMiningStore((state) => state.updateMiningStatus);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const convertToUserTimezone = (utcDate: string) => {
    const date = new Date(utcDate + 'Z');
    return date.toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: userTimeZone
    });
  };

  const getTimeRemaining = (endDate: string): TimeRemaining => {
    const now = new Date();
    const end = new Date(endDate + 'Z');
    const diff = end.getTime() - now.getTime();

    if (diff <= 0) {
      return {
        hours: 0,
        minutes: 0,
        seconds: 0,
        text: '0 м. 0 с.',
        updateInterval: 0,
        isCompleted: true
      };
    }

    const totalSeconds = Math.floor(diff / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const updateInterval = hours > 0 ? 1000 : 1000;
    const text = hours > 0 ? 
      `${hours} ч. ${minutes} м.` : 
      `${minutes} мин. ${seconds} с.`;

    return {
      hours,
      minutes,
      seconds,
      text,
      updateInterval,
      isCompleted: false
    };
  };

  const useTimeUpdate = (endDate: string | undefined, callback: (time: TimeRemaining) => void) => {
    useEffect(() => {
      if (!endDate) return;

      const updateTime = () => {
        const timeInfo = getTimeRemaining(endDate);
        callback(timeInfo);

        // Если майнинг завершен, обновляем статус и останавливаем таймер
        if (timeInfo.isCompleted) {
          updateMiningStatus('claim');
          return;
        }

        // Устанавливаем следующий интервал только если майнинг не завершен
        if (timeInfo.updateInterval > 0) {
          timeoutRef.current = setTimeout(updateTime, timeInfo.updateInterval);
        }
      };

      const timeoutRef = { current: null as NodeJS.Timeout | null };

      // Первое обновление
      updateTime();

      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }, [endDate, callback, updateMiningStatus]);
  };

  return { convertToUserTimezone, getTimeRemaining, useTimeUpdate };
};